import _, { get, isArray, isBoolean, isEmpty, isNaN, isNumber } from 'lodash';
import Cookies from 'js-cookie';
import qs from 'querystring';
import { logger } from './log';
import { BILLING_CYCLE } from '@/common/constants';

export const isEmptyVal = (value) => {
  if (value instanceof Date || isBoolean(value)) {
    return false;
  }

  return isNumber(value) ? isNaN(value) : isEmpty(value);
};

export const billingCycleIsMonthly = (period) => {
  return period === BILLING_CYCLE.MONTHLY;
};

export const billingCycleIsOneMonth = (period) => {
  return period === BILLING_CYCLE.ONE_MONTH;
};

export const billingCycleIsAnnual = (period) => {
  return period === BILLING_CYCLE.ANNUAL;
};

export const billingCycleToValueMap = {
  [BILLING_CYCLE.MONTHLY]: 1,
  [BILLING_CYCLE.QUARTERLY]: 3,
  [BILLING_CYCLE.ANNUAL]: 12,
  [BILLING_CYCLE.TWO_YEARS]: 24,
  [BILLING_CYCLE.THREE_YEARS]: 36,
};
export const getValueByBillingCycle = (period) => {
  return get(billingCycleToValueMap, period, billingCycleToValueMap[BILLING_CYCLE.MONTHLY]);
}

export const safeJSONParse = (jsonString, defaultValue = null) => {
  let json = defaultValue;
  try {
    json = JSON.parse(jsonString);
  } catch (e) {
    logger.error(e);
  }
  return json;
};

export const isDebug = process.env.NODE_ENV !== 'production';

export const isDevEnv = get(window.newBillingConfig, "isDevEnv", false);

export const getLang = Cookies.get('_zm_lang') || 'en-US'

export const compose = fns => {
  if (fns.length === 0) {
    return args => args;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return fns.reduce((fn1, fn2) => (...args) => fn1(fn2(...args)));
};

export const getQueryByLocationSearch = () => {
  const searchString = location.search?.replace(/^\?/g, '') || "";
  return qs.parse(searchString) || {};
}

export const noopPromise = () => Promise.resolve();

export const isMobile = () => {
  return /.*(mobile|android|iphone|ipad|phone).*/i.test(navigator.userAgent);
}

export const ensureArray = (val) => (Array.isArray(val) ? val : []);

/**
 * Synchronize existing parameters of browser URL to new URL
 * @param pathname
 * @param queryParams
 * @returns {string|string|*}
 */
export const updateHrefWithQueryParams = (pathname, queryParams, otherQueryParamInfo = {}) => {
  if (!(isArray(queryParams) && queryParams.length > 0)) {
    return pathname;
  }
  const currentUrl = new URL(window.location.href);
  // Check if pathname includes a domain
  let newUrl;
  let isAbsolute = false;
  try {
    newUrl = new URL(pathname);
    isAbsolute = true;
  } catch (e) {
    newUrl = new URL(pathname, window.location.origin);
  }
  queryParams.forEach(param => {
    if (currentUrl.searchParams.has(param) && !newUrl.searchParams.has(param)) {
      newUrl.searchParams.set(param, currentUrl.searchParams.get(param));
    }
  });

  _.keys(otherQueryParamInfo).forEach((param) => {
    newUrl.searchParams.set(param, _.get(otherQueryParamInfo, param));
  });

  return isAbsolute ? newUrl.href : newUrl.pathname + newUrl.search;
};

let transformElm = null
export function htmlTextToPlainText(htmlText) {
  if (!transformElm) {
    transformElm = document.createElement('div')
  }
  transformElm.innerHTML = htmlText
  const ret = transformElm.innerText
  transformElm.innerHTML = ''
  return ret
}

export const isLastPlanTypeInPlantypeList = (planType, planTypeList = []) => {
  return planTypeList.length === 1 && planTypeList.includes(planType)
}

export const formatSentence = (s) => {
  try {
    let ls = s.toLowerCase();
    return ls.replace(/^\b([a-z])/, function(match) {
      return match.toUpperCase();
    });
  }catch (e) {
    return s
  }
}
